export class EditorEditModel {
    public id: number;
    public firstName: string;
    public lastName: string;
    public email: string;
    public phoneNumber: string;
}
